import axios from 'axios';
import z from 'zod';

import { SERVICEBASEURL } from 'enums/serviceBaseUrls';
import { Optional } from 'functions/promiseExtensions';
import { createValidator } from 'functions/validation/zod';

export interface Request {
	productIds: string[];
	erpName: string;
}

export interface Response {
	data: ResponseData;
}

const ProductSchema = z.object({
	productId: z.string().nullable(),
	category: z.string().nullable(),
	currency: z.string().nullable(),
	description: z.string().nullable(),
	externalId: z.string().nullable(),
	externalUrl: z.string().nullable(),
	imageUrl: z.string().nullable(),
	name: z.string().nullable(),
	nutrients: z.record(z.number().nullable()),
	parentCategory: z.string().nullable(),
	price: z.number().nullable(),
	type: z.string().nullable(),
	volume: z.number().nullable(),
	weight: z.number().nullable(),
});

const ResponseDataSchema = z.record(ProductSchema);

export type ResponseData = z.infer<typeof ResponseDataSchema>;
const validator = createValidator(ResponseDataSchema);

export async function callApi(request: Request): Promise<Optional<ResponseData>> {
	if (!request.productIds.length) return Optional.Just({});
	const url: string = `${SERVICEBASEURL.AI}/erp/product/search/`;
	return (await axios.post(url, request).toOptionalFiltered(validator)).map((x) => x.data);
}
